import { useAppSelector } from "@hooks/store"
import { getTableDataHelper } from "@thelpers/getTableDataHelper"
import verifyResponse from "@thelpers/verifyResponse"
import { getChargesFromCompany } from "../services/GET/getChargesFromCompany"
import { getDeletedChargesFromCompany } from "../services/GET/getDeletedChargesFromCompany"
import { getChargeStatusList } from "../services/GET/getChargeStatusList"
import { deleteCharge } from "../services/DELETE/deleteCharge"
import { updateChargeStatus } from "../services/PUT/updateChargeStatus"
import { useCallback } from "react"

export const useCollectionAdministrationServices = () => {

    const auth = useAppSelector(state => state.auth)

    const getAllChargesService = useCallback(async ({ limit, skip, sort_by, sort_order, charge_status_id, setLoading, previousData, last, currentPage, actualLimit }) => {
        const res = await getChargesFromCompany({ token: auth.idToken, company_id: auth.currentRol, limit, skip, sort_by, sort_order, charge_status_id })
        const status = verifyResponse({ dataResponse: res.data, statusResponse: res.status, showToast: false })
        setLoading?.(false)
        if (!status) {
            throw new Error('Error in getAllDocumentsService')
        }
        const { data, metadata } = getTableDataHelper({ data: res.data.data, metadata: res.data.metadata, skip, previousData, last, currentPage, actualLimit })
        return { data, metadata }
    }, [auth.idToken, auth.currentRol])

    const getChargeStatusListService = useCallback(async ({ setLoading }) => {
        setLoading?.(true)
        const res = await getChargeStatusList({ token: auth.idToken })
        const status = verifyResponse({ dataResponse: res.data, statusResponse: res.status, showToast: false })
        setLoading?.(false)
        if (!status) {
            throw new Error('Error in getChargeStatusListService')
        }
        return res.data.data.map((item) => ({ id: item.charge_status_id, name: item.name }))
    }, [auth.idToken])

    const getDeletedChargesService = useCallback(async ({ limit, skip, sort_by, sort_order, setLoading, previousData, last, currentPage, actualLimit }) => {
        setLoading?.(true)
        const res = await getDeletedChargesFromCompany({ token: auth.idToken, company_id: auth.currentRol, limit, skip, sort_by, sort_order })
        const status = verifyResponse({ dataResponse: res.data, statusResponse: res.status, showToast: false })
        setLoading?.(false)
        if (!status) {
            throw new Error('Error in getDeletedChargesService')
        }
        const { data, metadata } = getTableDataHelper({ data: res.data.data, metadata: res.data.metadata, skip, previousData, last, currentPage, actualLimit })
        return { data, metadata }
    }, [auth.idToken, auth.currentRol])

    const updateChargeStatusService = useCallback(async ({ charge_id, setLoading }) => {
        setLoading?.(true)
        const res = await updateChargeStatus({ token: auth.idToken, charge_id })
        const status = verifyResponse({ dataResponse: res.data, statusResponse: res.status, showToast: true, message: 'Estado del cobro actualizado con exito' })
        setLoading?.(false)
        if (!status) {
            throw new Error('Error in updateChargeStatusService')
        }
        return res.data.data
    }, [auth.idToken])

    const deleteChargeService = useCallback(async ({ charge_id, setLoading }) => {
        setLoading?.(true)
        const res = await deleteCharge({ token: auth.idToken, charge_id })
        const status = verifyResponse({ dataResponse: res.data, statusResponse: res.status, showToast: true, message: 'Cobro eliminado con exito' })
        setLoading?.(false)
        if (!status) {
            throw new Error('Error in deleteChargeService')
        }
        return res.data.data
    }, [auth.idToken])

    return {
        getAllChargesService,
        getChargeStatusListService,
        getDeletedChargesService,
        updateChargeStatusService,
        deleteChargeService,
    }
}